import { RSAA, RSAACreator } from 'redux-api-middleware';
import { toApiFormat } from 'utils/api';
import { PasswordSecurityActionType as ActionType } from './passwordSecurity.actionTypes';
import { PasswordSecurityData } from './passwordSecurity.types';

export const fetchPasswordSecurity: RSAACreator<ActionType> = (baseUrl: string) => {
  return {
    [RSAA]: {
      endpoint: '/users/password-security',
      method: 'GET',
      types: [
        ActionType.FETCH_PASSWORD_SECURITY_REQUEST,
        ActionType.FETCH_PASSWORD_SECURITY_SUCCESS,
        ActionType.FETCH_PASSWORD_SECURITY_FAILURE,
      ],
      params: toApiFormat({ baseUrl }),
    },
  };
};

export const putPasswordSecurity: RSAACreator<ActionType> = (body: PasswordSecurityData, baseUrl: string) => {
  return {
    [RSAA]: {
      endpoint: '/users/password-security',
      method: 'PUT',
      types: [
        {
          type: ActionType.PUT_PASSWORD_SECURITY_REQUEST,
          meta: {
            lockScreen: true,
          },
        },
        ActionType.PUT_PASSWORD_SECURITY_SUCCESS,
        {
          type: ActionType.PUT_PASSWORD_SECURITY_FAILURE,
          meta: {
            ignoreNotFoundError: true,
          },
        },
      ],
      body: toApiFormat(body),
      params: toApiFormat({ baseUrl }),
    },
  };
};
